import { useState, type ReactNode } from 'react';
import { Icon } from './Icon';
import { MobileSheet } from './MobileSheet';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * I filtri di una lista, sul telefono.
 *
 * Sul computer non fa NIENTE: restituisce i suoi figli così come sono, senza
 * nemmeno un <div> intorno. Il desktop non cambia di un pixel.
 *
 * Sul telefono al loro posto mette un solo tasto "Filtri" e li sposta dentro un
 * pannello che sale dal basso. Il motivo è semplice: una barra con quattro
 * tendine, su 390px, diventa quattro righe alte quaranta pixel che spingono la
 * lista sotto la piega. Il filtro si usa una volta ogni tanto, la lista sempre:
 * chi si usa di rado si nasconde.
 *
 * Uso:
 *   <MobileFilters attivi={quantiFiltriAccesi}>
 *     <div className="filterbar filterbar--float">…</div>
 *   </MobileFilters>
 */
export function MobileFilters({
  children,
  /** Quanti filtri sono accesi adesso: finisce nel pallino sul tasto. */
  attivi = 0,
  /** Etichetta del tasto, se "Filtri" non è la parola giusta. */
  label = 'Filtri',
}: {
  children: ReactNode;
  attivi?: number;
  label?: string;
}) {
  const mobile = useIsMobile();
  const [open, setOpen] = useState(false);

  if (!mobile) return <>{children}</>;

  return (
    <>
      <button type="button" className="m-filter-btn" onClick={() => setOpen(true)} aria-haspopup="dialog" aria-expanded={open}>
        <Icon name="filter" size={14} />
        <span>{label}</span>
        {attivi > 0 && <span className="n">{attivi}</span>}
      </button>

      <MobileSheet
        open={open}
        onClose={() => setOpen(false)}
        title={label}
        footer={
          <button className="btn btn-primary m-block" onClick={() => setOpen(false)}>
            Vedi i risultati
          </button>
        }
      >
        <div className="m-filters-body">{children}</div>
      </MobileSheet>
    </>
  );
}
